import { render, staticRenderFns } from "./MottoField.vue?vue&type=template&id=2ff49106&"
import script from "./MottoField.vue?vue&type=script&lang=js&"
export * from "./MottoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports